<ellipse-icon [matTooltip]="tooltip"
              [matTooltipPosition]="tooltipPosition"
              iconName="fal fa-circle-info"
              iconSize="xl" />
